import { render, staticRenderFns } from "./CalendarioReservas.vue?vue&type=template&id=5db5a028"
import script from "./CalendarioReservas.vue?vue&type=script&lang=js"
export * from "./CalendarioReservas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports